interface SpecItem {
  key: string;
  value: string;
}

interface SpecProps {
  specs?: SpecItem[];
}

function sanitizeHtml(html: string): string {
  return html
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<(iframe|object|embed|form|input|textarea|button|link|meta)[^>]*\/?>/gi, '')
    .replace(/<\/(iframe|object|embed|form|input|textarea|button|link|meta)>/gi, '')
    .replace(/<img[^>]*>/gi, '')
    .replace(/\s*on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/href\s*=\s*["']javascript:[^"']*["']/gi, '');
}

export default function Spec({ specs = [] }: SpecProps) {
  if (!specs || specs.length === 0) {
    return (
      <div className="py-8 text-center">
        <p className="text-gray-500 dark:text-gray-400">אין מפרט טכני זמין</p>
      </div>
    );
  }

  return (
    <div className="w-full overflow-hidden">
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {specs.map((row) => (
          <div key={row.key} className={`flex flex-col py-4 sm:flex-row`}>
            <div className="mb-2 flex-shrink-0 sm:mb-0 sm:w-32 md:w-40">
              <dt className="text-right text-sm font-medium text-gray-900 dark:text-white">
                {row.key}
              </dt>
            </div>
            <div className="flex-1 sm:me-4">
              <dd
                className="text-right text-sm leading-relaxed text-gray-700 dark:text-gray-300"
                // biome-ignore lint/security/noDangerouslySetInnerHtml: server-sourced spec data, sanitized via sanitizeHtml
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(row.value) }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
